<header class="relative z-50 flex flex-wrap items-center justify-between px-6 py-6 bg-white shadow md:px-2">
  <!-- Logo -->
  <div class="flex items-center space-x-2 w-full">
	<a routerLink="{{this.tenantName}}/landingpage" class="md:max-w-[20%]">
		<img [src]="tenant.getImg(tenant.LOGO)" (click)="trackclick('header.landingpage')" alt="{{this.loadeddata['Name']}} By Collegiate Mobile Logo Logo" title="{{this.loadeddata['Name']}} By Collegiate Mobile Logo" class="" />
	</a>

	<!-- Hamburger Menu Button -->
	<div class="md:hidden relative z-50 grow justify-end flex">
		<button (click)="toggleMenu()" class="btn btn-ghost btn-sm">
			<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
			<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
			</svg>
		</button>
	</div>

	<!-- Desktop Menu -->
	<nav class="hidden md:flex md:items-center w-full justify-end">
		<a [routerLink]="['/', collegemobile, 'fan']" (click)="trackclick('header.fan')" class="btn-xs text-xl text-purple font-semibold mr-4">Fan Plans</a>
		<a [routerLink]="[collegemobile, 'student']" (click)="trackclick('header.student')" class="btn-xs text-xl text-purple font-semibold mr-4">Student Plans</a>
		<a *ngIf="facultyEnabled" [routerLink]="[collegemobile, 'shop-faculty-plans']" (click)="trackclick('header.shopfacultyplans')" class="btn-xs text-xl text-purple font-semibold mr-4">Faculty Plans</a>
		<a [routerLink]="[collegemobile, 'why']" (click)="trackclick('header.why')" class="btn-xs text-xl text-purple font-semibold mr-4">Why {{this.loadeddata['Name']}}?</a>
		<a [routerLink]="[this.tenant.getName(), 'landingpage']" fragment="supportAnchor" (click)="trackclick('header.support')" class="btn-xs text-xl text-purple font-semibold">FAQ</a>
		<button
			class="btn btn-ghost align-top flex px-2 items-center rounded-lg"
			(click)="trackclick('header.signin'); openModal()"
			[ngStyle]="{
				'border': '2px solid ' + (loadeddata?.PrimaryColor ),
				'color': loadeddata?.PrimaryColor 
			}"
			>
		<!-- materials icons can be replaced  -->
		<span
			class="material-symbols-outlined"
			[ngStyle]="{ 'color': loadeddata?.PrimaryColor }"
		>
			login
		</span>
		<span class="font-bold text-lg">Sign In</span>
		</button>
	</nav>

  </div>




  <!-- Mobile Menu (Overlay) -->
	<div *ngIf="isMenuOpen" class="fixed top-[6rem] left-0 w-full z-40 bg-white shadow md:hidden">
		<nav class="flex flex-col items-center space-y-4 py-4" (click)="toggleMenu()">
			<a [routerLink]="[ collegemobile, 'fan']" (click)="trackclick('header.fan')" class="btn btn-ghost text-purple font-bold">Fan Plans</a>
			<a [routerLink]="[collegemobile, 'student']" (click)="trackclick('header.student')" class="btn btn-ghost text-purple font-bold">Student Plans</a>
			<a *ngIf="facultyEnabled" [routerLink]="[collegemobile, 'shop-faculty-plans']" (click)="trackclick('header.shopfacultyplans')" class="btn btn-ghost text-purple font-bold">Faculty Plans</a>
			<a [routerLink]="[collegemobile, 'why']" (click)="trackclick('header.why')" class="btn btn-ghost text-purple font-bold">Why {{this.loadeddata['Name']}}?</a>
			<a [routerLink]="[this.tenant.getName(), 'landingpage']" fragment="supportAnchor" (click)="trackclick('header.support')" class="btn btn-ghost text-purple font-bold">FAQ</a>
			<button class="btn btn-primary btn-outline" (click)="trackclick('header.signin')" (click)="openModal()"[ngStyle]="{
    'border': '2px solid ' + (loadeddata?.PrimaryColor ),
    'color': loadeddata?.PrimaryColor 
  }"
>
<!-- materials icons can be replaced  -->
  <span
    class="material-symbols-outlined"
    [ngStyle]="{ 'color': loadeddata?.PrimaryColor }"
  >
    login
  </span>
  <span class="font-bold text-sm">Sign In</span>
</button>
		</nav>
	</div>
</header>
